export const container = `
  h-72 w-full
  bg-cover bg-no-repeat bg-center
  group
`;

export const gradientContainer = `
  h-full w-full px-6 pt-6 pb-px lg:p-6
  flex flex-col gap-6 text-center justify-center

  group-data-[has-image=false]:text-left
  group-data-[use-backdrop=true]:bg-base-black/30
`;

export const icon = `
  w-12 h-12 text-base-white mx-auto

  group-data-[use-backdrop=false]:text-primary-100
  group-data-[has-image=false]:mx-0
`;

export const microLocation = `
  text-base-white text-4xl md:text-5xl font-bold
  group-data-[use-backdrop=false]:text-primary-100
`;

export const macroLocation = `
  text-base-white text-2xl md:text-4xl -mt-3
  group-data-[use-backdrop=false]:text-primary-100
`;
